// main.tsx — Increment web entrypoint.
import React from 'react';
import ReactDOM from 'react-dom/client';
// Shared AuthZ-style button reskin (.btn-primary / .btn-success / etc.
// pulling --bs-btn-* through to the active --bs-primary / --color-on-*
// palette). Lives in lib/web so every SPA inherits the same chrome.
import 'common/buttons.css';
// StatusBadge's contrast-paired foregrounds (DESIGN.md C-MSG-2). Imported
// before index.css so the app's own rules still win.
import 'common/badges.css';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
